var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('department-list-selector',{ref:"selector",attrs:{"isClearable":true,"department-group":_vm.departmentGroup},model:{value:(_vm.departmentSource),callback:function ($$v) {_vm.departmentSource=$$v},expression:"departmentSource"}})}
var staticRenderFns = []

export { render, staticRenderFns }